import { API } from 'utils/Helper';

export const withdrawManual = async (data) => {
  const response = await fetch(`${API}/payment/api/withdrawal/manual`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const withdrawManualUsdt = async (data) => {
  const response = await fetch(`${API}/payment/api/withdrawal/manual/usdt`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const depositApiHome = async (data) => {
  const response = await fetch(`${API}/payment/api/paynow/apihome`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const verifyApiHome = async (data) => {
  const response = await fetch(`${API}/payment/wallet/verify/apihome`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getActiveDepositGateways = async () => {
  const response = await fetch(`${API}/payment/api/deposit-gateways/active`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getActiveWithdrawalGateways = async () => {
  const response = await fetch(`${API}/payment/api/withdrawal-gateways/active`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getCurrencies = async () => {
  const response = await fetch(`${API}/api/currencies`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const createDynamicDeposit = async (data) => {
  const response = await fetch(`${API}/payment/api/paynow/dynamic`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createDynamicWithdrawal = async (data) => {
  const response = await fetch(`${API}/payment/api/withdrawal/dynamic`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const dynamicDeposit = async (data) => {
  const response = await fetch(`${API}/payment/api/paynow/upi`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const depositUsdtGateway = async (data) => {
  const response = await fetch(`${API}/payment/createDeposit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const depositManual = async (data) => {
  const response = await fetch(`${API}/payment/api/paynow/manual`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};
